import { useTranslation } from 'react-i18next';
import { AddressTranslations } from '@chargify/address';

import { CreditCardFormTranslations } from '../forms/CreditCard';

export const usePaymentProfileTranslations = () => {
  const { t } = useTranslation(['payment-profile']);
  const translate = (key: string) => t(key, { ns: 'payment-profile' });

  const addressTranslations: AddressTranslations = {
    country: {
      label: translate('country_label'),
      placeholder: translate('country_placeholder'),
    },
    city: {
      label: translate('city_label'),
      placeholder: translate('city_placeholder'),
    },
    address: {
      label: translate('address_label'),
      placeholder: translate('address_placeholder'),
    },
    address2: {
      label: translate('address2_label'),
      placeholder: translate('address2_placeholder'),
    },
    state: {
      label: translate('state_label'),
      placeholder: translate('state_placeholder'),
    },
    zip: {
      label: translate('zip_label'),
      placeholder: translate('zip_placeholder'),
    },
    postalCode: {
      label: translate('postal_code_label'),
      placeholder: translate('postal_code_placeholder'),
    },
    region: {
      label: translate('region_label'),
      placeholder: translate('region_placeholder'),
    },
    error: {
      invalid: translate('error_invalid'),
      required: translate('error_required'),
    },
    input: {
      searchLabel: translate('type_to_search'),
      selectOptionLabel: translate('select_option'),
    },
  };

  const creditCardTranslations: CreditCardFormTranslations = {
    creditCardNumber: {
      label: translate('credit_card_label'),
      placeholder: translate('credit_card_placeholder'),
    },
    securityCode: {
      label: translate('security_code_label'),
      placeholder: translate('security_code_placeholder'),
    },
    expirationDate: {
      label: translate('expiration_date_label'),
    },
    firstName: {
      label: translate('first_name_label'),
      placeholder: translate('first_name_placeholder'),
    },
    lastName: {
      label: translate('last_name_label'),
      placeholder: translate('last_name_placeholder'),
    },
    error: {
      invalid: translate('error_invalid'),
      required: translate('error_required'),
    },
    tooltip: {
      threeDigit: translate('tooltip_cvv_three_digit'),
      fourDigit: translate('tooltip_cvv_four_digit'),
    },
  };

  return {
    addressTranslations,
    creditCardTranslations,
  };
};
